/** Исходный язык: русские строки в коде — это и есть идентификаторы сообщений. */
export const SOURCE_LOCALE = 'ru';

/** Держать в синхроне с `locales` в `lingui.config.ts`. */
export const SUPPORTED_LOCALES = ['ru', 'en'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

/** Только явный выбор пользователя; результат автоопределения сюда не пишется. */
export const LOCALE_STORAGE_KEY = 'imgame:locale';

/** Название языка на нём самом — так его находят в списке, не зная текущего языка интерфейса. */
export const LOCALE_LABELS: Record<AppLocale, string> = {
  ru: 'Русский',
  en: 'English',
};

export function isSupportedLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/** `en-US`, `EN_gb`, `en` → `en`; неподдерживаемый или пустой тег → `null`. */
export function normalizeLocale(tag: string | null | undefined): AppLocale | null {
  if (!tag) {
    return null;
  }

  const language = tag.trim().toLowerCase().split(/[-_]/)[0];
  return isSupportedLocale(language) ? language : null;
}
